module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/anatomy-src-decorators-user-is-authorized.json
// module id = 1991
// module chunks = 9740691001973